import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import NavBarListItem from 'components/NavKit/NavBarListItem'
import NavBarListItemDivider from 'components/NavKit/NavBarListItemDivider'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import { rem } from 'polished'
import { Fragment, useCallback } from 'react'
import styled from 'styled-components'

interface NavLink {
  label: string
  to?: string
  href?: string
}

interface Props {
  label: string
  items: Array<NavLink>
}

const DrawerItemsSection = styled.div`
  display: flex;
  flex-direction: column;
  padding-inline: ${rem(8)};
`

const DrawerListItem = styled(NavBarListItem)`
  padding-block: ${rem(12)};
  gap: ${rem(8)};
`

function SocieteNavBarMenuDrawer(props: Props) {
  const { label, items } = props
  const modalElement = useModalElementContext()

  const handleItemClick = useCallback(() => {
    modalElement.resolve()
  }, [modalElement])

  return <ModalBase mode="drawer">
    <ModalHeader title={label} />
    <ModalBody>
      <ModalContent flush>
        <DrawerItemsSection>
          {items.map(item => (
            <Fragment key={item.label}>
              <DrawerListItem
                title={item.label}
                to={item.to}
                href={item.href}
                onClick={handleItemClick}
              />
              <NavBarListItemDivider />
            </Fragment>
          ))}
        </DrawerItemsSection>
      </ModalContent>
    </ModalBody>
  </ModalBase>
}

export default SocieteNavBarMenuDrawer
